import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"width":"200px"},
  class: "d-inline-block"
}
const _hoisted_2 = {
  key: 1,
  class: "text-nowrap"
}

import {ref, computed} from 'vue';
import InlineSelect from "~/core-ui/vue/ui/InlineSelect.vue";
import {
    OperatorApplicationConfigInstance,
    STANDART_NOTIFICATION_SOUNDS
} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {__} from "~/ts/library/Translate";
import {getPathByFile} from "~/operatorApplication/ts/service/getPathByFile";


const __default__ = {
    name: "OperatorApplicationNotificationSoundConfig"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    title: {},
    repeat: {},
    repeatAvailable: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:repeat"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {



let model = _useModel<string>(__props, "modelValue");

let emits = __emit;

let file = ref<HTMLInputElement>();

let isNative = computed(() => {
    return OperatorApplicationPlatform.isNative;
});

let sounds = computed<{id: string, label: string}[]>(() => {
    let result = {...STANDART_NOTIFICATION_SOUNDS.value};
    if (model.value) {
        if (!result[model.value]) {
            if (isNative.value) {
                let path = require("path");
                result[model.value] = path.parse(model.value).base;
            }
        }
    }
    let array: {id: string, label: string}[] = [];
    for (let key in result) {
        if (result.hasOwnProperty(key)) {
            array.push({
                id: key,
                label: result[key]
            })
        }
    }

    return array;
});

let repeatDelay = computed(() => {
    let result = [{
        value: 0, label: __("Отключен").toLowerCase()
    }];
    for (let i of [5, 10, 15, 20, 30, 60]) {
        result.push({value: i, label: __("через %d секунд", i)});
    }
    for (let i of [2, 3, 4, 5]) {
        result.push({value: i * 60, label: __("через %d мин", i)});
    }
    return result;
});

function onFileSelect() {
    let fileItem: any = file.value.files[0];
    if (fileItem) {
        model.value = getPathByFile(fileItem);
    }
}

function onNewSound(value: string) {
    if (STANDART_NOTIFICATION_SOUNDS.value[value]) {
        let audio = document.createElement("audio");
        audio.src = OperatorApplicationConfigInstance.getFullSoundPath(value);
        audio.play();
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(_component_el_form_item, null, {
    default: _withCtx(() => [
      _createElementVNode("h5", null, _toDisplayString(__props.title) + ":", 1),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_unref(__)("Звук")) + ": ", 1),
          _createVNode(InlineSelect, {
            modelValue: _unref(model),
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
              onNewSound
            ],
            options: _unref(sounds).map(item => ({ value: item.id, label: item.label }))
          }, null, 8, ["modelValue", "options"])
        ]),
        (_unref(isNative))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(file).click())),
              class: "mr-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)("Добавить свой звук")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          type: "file",
          ref_key: "file",
          ref: file,
          class: "d-none",
          onChange: onFileSelect,
          accept: ".mp3,.wav,.ogg"
        }, null, 544),
        (__props.repeatAvailable)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createTextVNode(_toDisplayString(_unref(__)("Повтор")) + ": ", 1),
              _createVNode(InlineSelect, {
                "model-value": __props.repeat,
                options: _unref(repeatDelay).map(item => ({ value: item.value, label: item.label })),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(emits)('update:repeat', $event)))
              }, null, 8, ["model-value", "options"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})